// material
import { Container } from '@material-ui/core';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Edit from '../../components/operators/edit';
// components
import Page from '../../components/Page';
import { UserContext } from '../../contexts/UserContext';
// hooks
import useSettings from '../../hooks/useSettings';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';

// ----------------------------------------------------------------------

export default function EditOperator() {
  const { themeStretch } = useSettings();

  // Get locationId from path
  const params: any = useParams();
  const [id, setId] = useState<string>(params?.id);
  const [{ user }]: any = React.useContext(UserContext);

  return (
    <Page title="Edit operator">
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading="View operator"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Operators', href: PATH_DASHBOARD.operators },
            { name: 'View operator', href: PATH_DASHBOARD.operators }
          ]}
        />
        <Edit id={id} setId={(id: string) => setId(id)} disabled={!user.canEdit} />
      </Container>
    </Page>
  );
}
